import React from "react";
import DataTable from "react-data-table-component";
// import { useNavigate } from 'react-router-dom';
// import { Dropdown } from 'react-bootstrap';
import { IconTrash, IconEye } from "@tabler/icons-react";

const DatatablePpsItemDokumen = (props) => {
  // console.log(props);

  const columns = [
    {
      name: "Nama File",
      minWidth: "400px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row.nama_dokumen}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: "normal",
      },
    },
    {
      name: "Dokumen",
      minWidth: "100px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            // onClick={() => props.viewBase64File(row.dokumen, row.nama_dokumen)}
            onClick={() => props.viewBase64File(row.id)}
            className="btn btn-light-success btn-sm"
            type="button"
            disabled={props.loadingShowFrame}
          >
            <IconEye stroke={2} /> Lihat Dokumen
          </button>
        </>
      ),
    },
    // {
    //   name: "Status Sinkron",
    //   minWidth: "50px", // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       {row.syncSpeakOnline === "Ya" ? (
    //         <span type="button" className="badge badge-success">
    //           Sync
    //         </span>
    //       ) : (
    //         <span type="button" className="badge badge-danger">
    //           Not Sync
    //         </span>
    //       )}
    //     </>
    //   ),
    // },
    {
      name: "Aksi",
      minWidth: "100px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          {/* 
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-content">
              Aksi
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => props.handleHapus(row.id)}>
                Hapus Dokumen
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> 
          */}

          {props.role === "Kelompok Kerja" ||
            props.role === "Surveior Internal" ? (
            <>
              <button
                className="btn btn-sm btn-outline-danger"
                type="button"
                title="Hapus Dokumen"
                onClick={() => props.handleHapus(row.id)}
              >
                <IconTrash stroke={2} />
              </button>

              {/* {row.syncSpeakOnline === "Tidak" ? (
                <button
                  className="btn btn-sm btn-outline-warning"
                  type="button"
                  title="Sync Dokumen PPS"
                  onClick={() => props.syncOneDocPps(row.id)}
                  disabled={props.disabledBtnSync}
                >
                  <IconRefresh stroke={2} />
                </button>
              ) : (
                ""
              )} */}
            </>
          ) : (
            ""
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <div style={{ overflowX: "auto", maxWidth: "1200px" }}>
        <DataTable
          columns={columns}
          data={props?.listdokumen}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search Dokumen Item PPS"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatablePpsItemDokumen;
